export default {

    formRow: {
        display: "flex",
        flex: '1 1 0%', 
        width: '66%'
    },

    fieldContainer: {
        wdisplay: 'flex', 
        flexDirection: 'column', 
        width: '95%'
    },

    stateContainer: {
        wdisplay: 'flex', 
        flexDirection: 'column', 
        width: '95%',
        marginLeft: '3%'
    },
}